module.exports = __webpack_public_path__ + "mf-1.8764288.png";